<template>
    <div class="flex items-center gap-2">
        <!-- Date picker -->
        <input
        type="date"
        v-model="localDate"
        class="border p-2 rounded bg-octo-secondary-20"
        />

        <!-- Time picker -->
        <input
        type="time"
        v-model="localTime"
        class="border p-2 rounded bg-octo-secondary-20"
        />

        <!-- Bouton clear -->
        <button
        v-if="modelValue"
        @click="clearDate"
        class="text-gray-400 hover:text-black"
        type="button"
        >✕</button>
    </div>
</template>

<script setup>
import { computed } from 'vue'


const props = defineProps({
     modelValue: { type: String, default: null }
})
const emit = defineEmits(['update:modelValue'])


const localDate = computed({
    get() {
        if (!props.modelValue) return ''
        // "YYYY-MM-DDTHH:mm:ss.sssZ" → "YYYY-MM-DD"
        return props.modelValue.slice(0, 10)
    },
    set(val) {
        if (!val) {
            emit('update:modelValue', null)
            return
        }

        const d = props.modelValue ? new Date(props.modelValue) : new Date()
        const [Y, M, D] = val.split('-').map(Number)
        d.setFullYear(Y, M - 1, D)
        emit('update:modelValue', d.toISOString())
    }
})

const localTime = computed({
    get() {
        if (!props.modelValue) return ''
        const d = new Date(props.modelValue)
        const pad = n => String(n).padStart(2, '0')
        return `${pad(d.getHours())}:${pad(d.getMinutes())}`
    },
    set(val) {
        if (!val) {
            emit('update:modelValue', null)
            return
        }
        const d = props.modelValue ? new Date(props.modelValue) : new Date()
        const [h, m] = val.split(':').map(Number)
        d.setHours(h, m, 0, 0)
        emit('update:modelValue', d.toISOString())
    }
})

function clearDate() {
    emit('update:modelValue', null)
}
</script>
